import {getTextByValue} from "@utilities/Types/listUtilities";
import {APH_LOAN_STATUS_LIST} from "./aphLoanConstants";
import {updateAphLoanItemModel} from "./aphLoanFactory";
import {isNullOrUndefined} from "@utilities/commonUtilities";
import type { AphLoanItem, ShippingLocation } from './aphLoan.types';
import {isObjectNullOrEmpty} from "@utilities/Types/objectUtilities";

export const getLoanAphStatusTextByValue = (value: string | number = "") => getTextByValue(APH_LOAN_STATUS_LIST, value);

export async function copyToClipboard(textToCopy: string, successMessage: string = "Copied to clipboard.") {
    if (!navigator.clipboard) {
        alert("Copy not supported. Try again.");
        return;
    }
    try {
        await navigator.clipboard.writeText(textToCopy);
        alert(successMessage);
    } catch (err) {
        alert("Copy failed. Try again.");
    }
}


export function getChangedAphLoanItemsForUpdate(aphLoanItems: AphLoanItem[], originalAphLoanItems: AphLoanItem[]) {
    return aphLoanItems
        .filter((item: AphLoanItem) => {
            const originalAphLoanItem = originalAphLoanItems.find((o: AphLoanItem) => o.aphLoanItemId === item.aphLoanItemId);

            if (!originalAphLoanItem) return false;

            const statusChanged = originalAphLoanItem.aphLoanStatus !== item.aphLoanStatus;
            const notesChanged = (originalAphLoanItem.aphLoanNotes || "") !== (item.aphLoanNotes || "");

            return statusChanged || notesChanged;
        })
        .map((item: AphLoanItem) => updateAphLoanItemModel({
            aphLoanItemId: item.aphLoanItemId,
            aphLoanStatus: item.aphLoanStatus,
            aphLoanNotes: item.aphLoanNotes,
        }));
}

export function convertToCurrencyFormat(value: string | number) {
    if (isNaN(Number(value)) || isNullOrUndefined(value)) {
        return "";
    }
    return `$ ${parseFloat(String(value)).toFixed(2)}`;
}

export const formatShippingAddress = (shippingLocation: ShippingLocation): string => {

   const addressTwo = !isNullOrUndefined(shippingLocation.address2) && !isObjectNullOrEmpty(shippingLocation.address2.trim())  ? `\n${shippingLocation.address2.trim()}` : "";
    return `${shippingLocation.name}\n${shippingLocation.address}${addressTwo}\n${shippingLocation.city}, ${shippingLocation.state} ${shippingLocation.zipCode}`;
};
